import { i as r } from "./factory-ueRxoNOV.js";
import { r as a } from "./rem-CMQJ_ZTp.js";
function t(n, e = "size", i = !0) {
  if (n !== void 0)
    return r(n) ? i ? a(n) : n : `var(--${e}-${n})`;
}
function f(n) {
  return t(n, "mantine-spacing");
}
function m(n) {
  return n === void 0 ? "var(--mantine-radius-default)" : t(n, "mantine-radius");
}
function s(n) {
  return t(n, "mantine-font-size");
}
function d(n) {
  return t(n, "mantine-line-height", !1);
}
function g(n) {
  if (n)
    return t(n, "mantine-shadow", !1);
}
export {
  s as a,
  f as b,
  t as c,
  g as d,
  m as e,
  d as g
};
